import { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';
import HomePage from '../pages/home/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;